import React from 'react';
export function Footer() {
  return <footer className="bg-dark-card border-t border-dark-border pt-16 pb-8 px-4 text-center" data-id="element-144">
      <div className="max-w-4xl mx-auto" data-id="element-145">
        <div className="mb-8" data-id="element-146">
          <div className="inline-flex items-center space-x-2 text-2xl font-black mb-4" data-id="element-147">
            <span data-id="element-148"></span>
            <span data-id="element-149">ULTRAPACK DIGITAL™</span>
          </div>
          <p className="text-gray-400 max-w-md mx-auto" data-id="element-150">
            El sistema de generación de ingresos N°1 para emprendedores desde
            casa en Argentina.
          </p>
          <p className="text-brand font-bold mt-2" data-id="element-151">
            Porque emprender no debería costarte tu tranquilidad financiera ni
            tu tiempo en familia.
          </p>
        </div>

        <div className="flex flex-wrap justify-center gap-6 text-sm text-gray-500 mb-12" data-id="element-152">
          <a href="mailto:soporte@ultrapack-digital.com" className="hover:text-brand transition-colors" data-id="element-153">
            📧 soporte@ultrapack-digital.com
          </a>
          <a href="#" className="hover:text-brand transition-colors" data-id="element-154">
            📱 @ultrapack.digital
          </a>
          <a href="https://desayunos.ultrapack-digital.com" className="hover:text-brand transition-colors" data-id="element-155">
            🌐 desayunos.ultrapack-digital.com
          </a>
        </div>

        <div className="border-t border-dark-border/50 pt-8 text-xs text-gray-600" data-id="element-156">
          <p className="mb-4" data-id="element-157">
            © UltraPack Digital™ 2026 — Todos los derechos reservados.
            Prohibida la reproducción y redistribución sin autorización expresa.
          </p>
        </div>
      </div>
    </footer>;
}